import moment from 'moment';
export const fmtDate = function fmtDate(d) {
	if (!d) {
		return '-';
	}

	return moment(d).format('MMM-D');
};

/**
 * Format to military time
 */
export const fmtMilTime = function fmtMilTime(d) {
	if (!d) {
		return '-';
	}

	return moment(d).format('HH:mm');
};

export const breakStatusIntoArray = function breakStatusIntoArray(status) {
	if (!status) {
		return ['-'];
	}
	// Split the string by '> ' to separate each date-location entry.
	return status.split('>').map((entry) => entry.trim());
};
